import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import WorkingSolutionCalculator from '../components/stock-solution/WorkingSolutionCalculator';

const WorkingSolutionPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Working Solution Calculator
        </Typography>
        <Typography variant="body1" paragraph>
          Calculate the perfect dilution for your stock solutions to create accurate working solutions for your hydroponic system.
        </Typography>
        
        <Paper elevation={0} sx={{ p: 0, mt: 3 }}>
          <WorkingSolutionCalculator />
        </Paper>
      </Box>
    </Container>
  );
};

export default WorkingSolutionPage;
